import axios from 'axios';

const { apiHost = '' } = window.EasyDeskConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

export default wootAPI;
